import { render } from "./AddModeleBoiteModal.vue?vue&type=template&id=665a6bb0&ts=true"
import script from "./AddModeleBoiteModal.vue?vue&type=script&lang=ts"
export * from "./AddModeleBoiteModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__